import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { MODAL_TYPE } from './Modal'
import Glyph from 'component/utils/Glyph'

const LDAP_COLUMN_WIDTH = "10%"
const STORE_COLUMN_WIDTH = "22%"
const DATE_COLUMN_WIDTH = "13%"
const NOTES_COLUMN_WIDTH = "13%"
const VERSION_COLUMN_WIDTH = "16%"
const STATUS_COLUMN_WIDTH = "10%"
const EDIT_COLUMN_WIDTH = "8%"
const REMOVE_COLUMN_WIDTH = "8%"

const ReleasesTable = ({
//   translate,
openModal,
mobileUpdates
  
}) => {
  const tableRef = useRef(null)

  const renderHeader = () => (
      <tr className='pictograms-tr'>
       <th style={{width: LDAP_COLUMN_WIDTH}} >LDAP</th>
       <th style={{width: STORE_COLUMN_WIDTH}} >Loja</th>
       <th style={{width: DATE_COLUMN_WIDTH}} >Data da atualização</th>
       <th style={{width: NOTES_COLUMN_WIDTH}} >Notas da atualização</th>
       <th style={{width: VERSION_COLUMN_WIDTH}} >Versão</th>
       <th style={{width: STATUS_COLUMN_WIDTH}} className='text-center' >Status</th>
       <th  style={{width: EDIT_COLUMN_WIDTH}}  className='text-center'>
         Editar
       </th>
      
       <th  style={{width: REMOVE_COLUMN_WIDTH}} className='text-center'>
         Excluir
       </th>
       
      </tr>
  )
    
  const renderBody = () => {

    const renderRecord = (record) => {
      const {idUpdate, inUpdate,idVersion, dsLdap,dsBranch,updateDate,updateNotes, isPortalUpdate, idBranch} = record
     
      const hasLdap = !isEmpty(dsLdap)
      const hasStore = !isEmpty(dsBranch)

      // Label text
      const ldapLabel = !hasLdap
        ? "Todos"
        : dsLdap[0].split(",").length === 1
        ? dsLdap
        : "Vários"; 
      
      const notesLabel = isPortalUpdate ? "Portal" : !isEmpty(idVersion) ? idVersion : "-"

      const handleCopyToClipboard = (event) => {
        navigator.clipboard.writeText(dsLdap.join(", "));
      
        // Icon animation
        const icon = event.currentTarget;
        icon.classList.add("animate-scale");
      
        setTimeout(() => icon.classList.remove("animate-scale"), 250);
      };

      return (
        <tr key={idUpdate}>
        
          <td 
            className="CellWithComment" 
            style={{ width: '80%', display: "flex", alignItems: "center", justifyContent: "center", marginTop:"3.5px"}}
          >
            <span className="list-description ">{ldapLabel}</span>
            {ldapLabel === "Vários" && (
                <Glyph
                  customClass="cursor-pointer small-icon"
                  type="clone"
                  color="primary"
                  font= '12px'
                  onClick={handleCopyToClipboard}
                />
            )}
            {ldapLabel === "Vários" && (
              <span >
                <span className="CellComment">{dsLdap.join(", ")}</span>
              </span>
            )}
          </td>

          <td style={{width: "25%",textTransform: "capitalize"}} > {hasStore ? dsBranch : "Todas"}</td>
          <td style={{width: DATE_COLUMN_WIDTH, fontSize: '14px', display: 'flex', flexDirection: "row", alignItems: "center", gap: "15px"}} >  
              {!isEmpty(updateDate) ? updateDate : "-"}
          </td>

          <td style={{width: NOTES_COLUMN_WIDTH,textTransform: "capitalize"}} >{!isEmpty(updateNotes) ? "Sim" : "Não"} </td>
          <td style={{width: VERSION_COLUMN_WIDTH,textTransform: "capitalize"}} >{notesLabel}</td>
      

          <td className='text-center' style={{width: STATUS_COLUMN_WIDTH,textTransform: "capitalize"}} >{
            isPortalUpdate ? "Postado!" : inUpdate ? "Atualizado!" :  
            <span  onClick={() => openModal(MODAL_TYPE.UPDATE, { idBranch, dsBranch, dsLdap, idVersion, idUpdate })} 
                  style={{textDecorationLine: "underline", textDecorationStyle: "solid",cursor: "pointer", textDecorationColor: "#41A017", color: "#41A017"}}>Atualizar agora</span>
            }
            </td>

          <td onClick={
                inUpdate === 1 ? () => {} :
                isPortalUpdate
                  ? () => openModal(MODAL_TYPE.REWRITE, { updateNotes })
                  : () =>
                      openModal(MODAL_TYPE.EDIT, {
                        idUpdate,
                        updateNotes,
                        idBranch,
                        dsLdap,
                        dsBranch,
                        idVersion,
                      })
              } style={{width: EDIT_COLUMN_WIDTH}} className='text-center'>
          
            <i style={{cursor: 'pointer', color: inUpdate === 1 && "6F676C" }} className={ `glyph glyph-pencil icon-size color-primary ${(isPortalUpdate || inUpdate - 1) ? "" : "disabled"}`} />
            
          </td>

          <td onClick={() =>
                inUpdate === 1 ? () => {} :
                openModal(MODAL_TYPE.DELETE, { idVersion, dsLdap, idUpdate })
              } style={{width: REMOVE_COLUMN_WIDTH}} >
            
            <i style={{cursor: 'pointer', color: inUpdate === 1 && "#6F676C" }} className={`glyph glyph-trash-can icon-size color-danger ${(isPortalUpdate || inUpdate - 1) ? "" : "disabled"}`} />
          </td>
          
        </tr>
      
      )
    }

    return mobileUpdates.map(renderRecord)
  }

  return (
    <table  cellPadding={0} cellSpacing={0} className={`supply-list-table-new new pictograms-table }`}>
      <thead ref={tableRef}>{renderHeader()}</thead>
      <tbody className='tbody-mission-block'  onScroll={(e) => {
        if(e.currentTarget.scrollTop > 20) {
          tableRef.current.classList.add("shadow-table-header-mission-block")
        }
        else {
          tableRef.current.classList.remove("shadow-table-header-mission-block")
        }
      }} >{renderBody()}</tbody>
      <tfoot style={{height: "1px",background:"#D3D2D6"}}></tfoot>
    </table>
  )
}

ReleasesTable.propTypes = {

  mobileUpdates: PropTypes.array.isRequired,
  openModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default ReleasesTable
